import { createSlice } from "@reduxjs/toolkit";
import { defaultState } from "../../interfaces/auth";
import { updateProfileImgThunk } from "../../asyncThunks/profile/Myprofile";

const initialState: defaultState = {
    error: null,
    data: null,
    loading: false,
};

export const updateProfileImg = createSlice({
    name: "updateProfileImg",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(updateProfileImgThunk.pending, (state, action) => {
            state.error = null;
            state.data = null;
            state.loading = true;
        });
        builder.addCase(updateProfileImgThunk.fulfilled, (state, action) => {
            if (action?.payload?.status?.toLowerCase() === "success") {
                state.error = null;
                state.data = action.payload;
            } else {
                state.error = action?.payload;
                state.data = null;
            }
            state.loading = false;
        });
        builder.addCase(updateProfileImgThunk.rejected, (state, action) => {
            state.error = action.payload;
            state.data = null;
            state.loading = false;
        });
    },
});

export default updateProfileImg.reducer;
